import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import GoogleBusinessProfileClaimCard from '../../../Admin/ServiceTypes/GoogleMyBusiness'

import ServiceCardBase from '../../ServiceCardBase'

function GoogleBusinessProfile({ onSave, onCancel}){
    const dispatch = useDispatch()
    
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        gmb: undefined
                    }
                }
            }
        }))
    }


    return <ServiceCardBase 
        title="Google Business Profile" 
        header="Google Business Profile" 
        description=" "
        image={serviceMap.gmb.img}>
            <GoogleBusinessProfileClaimCard design="onboarding" />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.gmb && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {siteForm?.attr?.accounts?.gmb && oauthTokens?.gmb ? <button id="saveGbp" className="btn btn-lg btn-primary" onClick={async() => {
                        await onSave("gmb")
                    }}>Save</button> : <span></span>}
                </div>
                {(!siteForm?.attr?.accounts?.gmb || localStorage.getItem("gmbSelection") === null) && <button className="btn btn-lg btn-link" onClick={() =>onCancel("gmb")}>Claim Later</button>}
            </div>
    </ServiceCardBase>
}

export default GoogleBusinessProfile